/* global $ */
import React, { Component } from 'react';
import {SaveConfirmation} from './windows/SaveConfirmation';
import {RedirectToManagementConsoleConfirmation} from './windows/RedirectToManagementConsoleConfirmation';
import CheckMark from './../images/done.svg';
import { Button } from 'semantic-ui-react';

export class CompleteState extends Component {
    showSaveModal() {
        $('#saveConfirmation .content p').html(this.props.showMessage("message_9_01") + ' <span class="purple">\'' + this.props.showMessage("message_9_02") + '\'</span> ' + this.props.showMessage('message_9_03'));
        $('#saveConfirmation .actions #cancelButton').text(this.props.showMessage('message_9_04'));
        $('#saveConfirmation .actions #saveButton').text(this.props.showMessage('message_9_02') + ' >');
        $('#saveConfirmation').modal('show');
    }

    showSaveAndRedirectModal() {
        $('#saveAndRedirectConfirmation .content p').html(this.props.showMessage('message_10_01') + ' <span class="purple">\'' + this.props.showMessage('message_10_02') + '\'</span> ' +  this.props.showMessage('message_10_03') + ' <span class="purple">\'' + this.props.showMessage('message_10_04') + '\'</span> ' +  this.props.showMessage('message_10_05'));
        $('#saveAndRedirectConfirmation .actions #cancelButton').text(this.props.showMessage('message_10_04'));
        $('#saveAndRedirectConfirmation .actions #saveButton').text(this.props.showMessage('message_10_02') + ' >');
        $('#saveAndRedirectConfirmation').modal('show');
    }

    showTitle() {
        var text = "";
        if (this.props.isSettingsSkipped) {
            text = this.props.showMessage('message_8_01') + '<br/>';
            text += this.props.showMessage('message_8_10')
        } else {
            if (!this.props.isSaved) {
                text = this.props.showMessage('message_8_01') + '<br/>';
                text += this.props.showMessage('message_8_02');
            } else {
                text = this.props.showMessage('message_8_12');
            }
        }
        return {__html: text};
    }

    showText() {
        if (!this.props.isSettingsSkipped) {
            if (this.props.isSaved) {
                return {__html: ""}
            } else {
                return {__html: this.props.showMessage('message_8_03') + ' <span class="purple">' + this.props.showMessage('message_8_08') + '</span> ' + this.props.showMessage('message_8_06')};
            }
        } else {
            return {__html: this.props.showMessage('message_8_11')};
        }
    }

    render() {
        return (
            <div className="outerContent">
                <div className="innerContent">
                    <h2 className="purple title" dangerouslySetInnerHTML={this.showTitle()}/>
                    <img src={CheckMark} style={{maxWidth: '150px'}} />
                    <p className="title"><span dangerouslySetInnerHTML={this.showText()} /> {this.props.showMessage('message_8_09')} <span className="purple">{this.props.showMessage('message_8_04')}</span> {this.props.showMessage('message_8_07')}</p>
                </div>
                {(!this.props.isSettingsSkipped && !this.props.isSaved) ?
                    <div className="footer">
                        <Button className="primary formButtons" onClick={this.showSaveModal.bind(this)}>{this.props.showMessage('message_8_05')} ></Button>
                    </div> :
                    null
                }
                <SaveConfirmation submitRegistration={this.props.submitRegistration}
                                  showMessage={this.props.showMessage}
                                  showLogin={this.props.showLogin}/>
                <RedirectToManagementConsoleConfirmation submitRegistration={this.props.submitRegistration}
                                                         showMessage={this.props.showMessage}
                                                         lang={this.props.lang}
                                                         showLogin={this.props.showLogin}/>
            </div>
        )
    };

    goToManagementConsole() {
        if (this.props.isSaved) {
            window.location = "https://manage.odyssys.net/login";
        } else {
            this.showSaveAndRedirectModal();
        }
    };
};


// WEBPACK FOOTER //
// ./src/components/CompleteState.jsx